import React from "react";
import { Input } from "reactstrap";
import "./input.css";

const FormikInput = ({ field, ...props }) => {
  const haveValueStyles = () => {
    const result = props.className || "";
    if (field && field.value) {
      return result.concat(" background-have-value");
    }

    return result;
  };

  return <Input {...field} {...props} className={haveValueStyles()} />;
};

export default FormikInput;



// WEBPACK FOOTER //
// ./src/components/formik/Input.jsx